import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './index.scss';
import i18n from '@/i18n';
import { ROUTE_PATH, PRODUCT_GRADE_TYPE } from '@/utils/Global';
import { SetIsShowLoginDialog, SetIsShowSignUpDialog } from '@/Interface';
import SignUpDialog from '@/Navigator/SignUpDialog';
import LoginDialog from '@/Navigator/LoginDialog';
import SignUpSelection from '@/Navigator/SignUpSelection';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { OpenPopUp } from '@/LoginPopupHandler';
import { SetTrackingData } from '@/utils/TrackingData';

const TopBarV2 = ({ history, minWidth, hideMenuArea = false, black = false }) => {
    const credits = useSelector(state => state.creditsStateStore.creditsState);
    const myProfileURL = useSelector(state => state.myProfileURLStore.myProfileURL);
    const currentUser = useSelector(state => state.userStore.user);
    const value = useSelector(state => state.langStore.lang);
    const currentPath = useSelector(state => state.currentPathStore.currentPath);
    const isShowSignUpPopup = useSelector(state => state.signUpPopupShowStore.isShowSignUpPopup);
    const isShowLoginPopup = useSelector(state => state.loginPopupShowStore.isShowLoginPopup);
    const paymentMode = useSelector(state => state.paymentModeStore.paymentMode);
    
    const [isShowSignUpSelector, setIsShowSignUpSelector] = useState(false);
    const aiDropdownRef = useRef(null);
    const designDropdownRef = useRef(null);
    const urlDropdownRef = useRef(null);

    const handleLogoClick = () => {
        history.push('/');
    };

    const handleMyPageClick = () => {
        if (currentUser && currentUser.email) {
            history.push(ROUTE_PATH.MY_VIDEOS);
        }
    };

    const handleUpgradeClick = () => {
        history.push('/payment');
    };

    const handleAiItemClick = (path) => {
        history.push(path);
    };

    const handleDesignItemClick = (path) => {
        history.push(path);
    };

    const handleUrlItemClick = (path) => {
        history.push(path);
    };

    const handleSignUpDialogOpen = () => {
        setIsShowSignUpSelector(false)
        SetIsShowSignUpDialog(true)
    }

    const handleClickThirdPartyLogin = (url, isSignup = false) => {
        const lang = value;
        if (isSignup) SetTrackingData({ lang })
        else SetTrackingData({ lang, isLogin: true })
        OpenPopUp(url)
    }

    const renderPlanSection = () => {
        if (!paymentMode) {
            return <div className={`plan-section ${black ? 'black' : ''}`}>
                <span className="upgrade-btn" onClick={handleUpgradeClick}>Upgrade</span>
                <span className="current-plan">{i18n.t("common.use.payment.free")}</span>
            </div>
        }
        const isAdmin = paymentMode && paymentMode.admin ? true : false;

        let productName, productGradeType
        if (paymentMode && paymentMode.product && paymentMode.product.productName) {
            productName = paymentMode.product.productName[value] || paymentMode.product.productName['en']
        }
        if (paymentMode && paymentMode.product && paymentMode.product.gradeType) {
            productGradeType = paymentMode.product.gradeType
        }

        let planClassName = "";
        let planSection;
        if (isAdmin) {
            planClassName = "admin";
            planSection = <span className="current-plan">Admin 계정 이용중</span>
        }
        else {
            switch (productGradeType) {
                case PRODUCT_GRADE_TYPE.BASIC:
                    planClassName = "basic";
                    planSection = <span className="current-plan">{i18n.t("common.use.payment.basic")}</span>
                    break;
                case PRODUCT_GRADE_TYPE.STANDARD:
                    planClassName = "standard";
                    planSection = <span className="current-plan">{i18n.t("common.use.payment.standard")}</span>
                    break;
                case PRODUCT_GRADE_TYPE.PRO:
                    planClassName = "pro";
                    planSection = <span className="current-plan">{i18n.t("common.use.payment.pro")}</span>
                    break;
                case PRODUCT_GRADE_TYPE.ACADEMY:
                    planClassName = "academy";
                    planSection = <span className="current-plan">{i18n.t("common.use.payment.academy")}</span>
                    break;
                default:
                    if (productName) {
                        planClassName = "unknown";
                        planSection = <span className="current-plan">{productName}</span>
                    }
                    break;
            }
        }

        if (!planClassName) return <></>;

        return (
            <div className={`plan-section ${planClassName ? `plan ${planClassName}` : ""} ${black ? 'black' : ''}`}>
                {planSection}
            </div>
        )
    }

    const renderLoginAfter = () => {
        return (
            <>
                <div className="credit-section">
                    <img src="https://front.videomonster.com/images-u6yd72dy/common/ai/v2-credit.svg" alt="credit" />
                    <span>{credits}</span>
                    <span>{i18n.t("common.credit.my")}</span>
                </div>
                {renderPlanSection()}
                <div className="my-page-section" onClick={handleMyPageClick}>
                    {/* <span>마이 페이지</span> */}
                    <div className="user-profile-wrap">
                        {myProfileURL && <img src={myProfileURL === 'baseImg' ? "https://front.videomonster.com/images-u6yd72dy/common/v2-profile.svg" : myProfileURL} alt="profile" />}
                    </div>
                </div>
            </>
        )
    }

    const renderLoginBefore = () => {
        return (
            <div className='login-before'>
                <div className='login-button' onClick={() => window.open('https://eclogin.cafe24.com/Shop/', '_self')}>{i18n.t("Cafe24.header.login.button")}</div>
            </div>
            // <div className="login-btn-area">
            //     <div className="login-btn" onClick={() => SetIsShowLoginDialog(true)}>
            //         <p lang={value}>{i18n.t("global.login")}</p>
            //     </div>
            //     |
            //     <div className="signup-btn" onClick={() => {
            //         setIsShowSignUpSelector(!isShowSignUpSelector)
            //     }}>
            //         <p lang={value}>{i18n.t("global.signup")}</p>
            //     </div>
            // </div>
        )
    }
    
    const isAiToolsActive = currentPath.includes(ROUTE_PATH.AI_TOOLS) || 
                           currentPath.includes(ROUTE_PATH.IMAGE_GENERATION) || 
                           currentPath.includes(ROUTE_PATH.VIDEO_GENERATION);
                           
    const isDesignActive = currentPath.includes(ROUTE_PATH.DESIGN_SELECT) ? true : false;
    
    const isUrlActive = currentPath.includes('/url-to-video') || 
                       currentPath.includes('/youtube-shorts');

    const topBarV2Style = {}
    if (minWidth) topBarV2Style.minWidth = minWidth;

    return (
        <div className={`cafe24-top-bar-v2 ${black ? 'black' : ''}`} style={topBarV2Style}>
            <div className="cafe24-logo-area" onClick={handleLogoClick}>
                <img src={black ? "https://front.videomonster.com/images-u6yd72dy/common/v2-logo.svg" : "https://front.videomonster.com/images-u6yd72dy/common/v2-logo-dark.svg"} alt="logo" />
            </div>

            <div className="cafe24-menu-area">
                {!hideMenuArea && (
                    <>
                        <div ref={aiDropdownRef} className={`item dropdown-container ${isAiToolsActive ? 'selected' : ''}`}>
                            <div className="dropdown-trigger">
                                <img style={{ marginTop: '1px' }} src={isAiToolsActive ? 'https://front.videomonster.com/images-u6yd72dy/common/ai/ai-tool-black-icon-new.svg' : 'https://front.videomonster.com/images-u6yd72dy/common/ai/ai-tool-black-icon-new.svg'} alt='' />
                                <p>{i18n.t("navigator.menu.ai")}</p>
                            </div>

                            <div className={`dropdown-menu ${black ? 'black' : ''}`}>
                                <div className="dropdown-item" onClick={() => handleAiItemClick(ROUTE_PATH.AI_TOOLS)}>
                                    <img className="dropdown-icon" src={black ? "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-ai-tools-white.svg" : "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-ai-tools.svg"} alt='' />
                                    <span className="dropdown-text">{i18n.t("web.menu.ai.tools")}</span>
                                </div>
                                {/* TO-DO :: 스케치 투 이미지 임시 로직 */}
                                {/* <div className="dropdown-item" onClick={() => handleAiItemClick(ROUTE_PATH.SKETCH_TO_IMAGE)}>
                                    <img className="dropdown-icon" src={black ? "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-image-gen-white.svg" : "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-image-gen.svg"} alt='' />
                                    <span className="dropdown-text">{i18n.t("web.menu.ai.image.generation")}</span>
                                </div> */}
                                <div className="dropdown-item" onClick={() => handleAiItemClick(ROUTE_PATH.IMAGE_TO_VIDEO)}>
                                    <img className="dropdown-icon" src={black ? "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-video-gen-white.svg" : "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/1-video-gen.svg"} alt='' />
                                    <span className="dropdown-text">{i18n.t("web.menu.ai.video.generation")}</span>
                                </div>
                            </div>
                        </div>

                        <div ref={designDropdownRef} className={`item dropdown-container ${isDesignActive ? 'selected' : ''}`}>
                            <div className="dropdown-trigger">
                                <p>{i18n.t("navigator.menu.designselect")}</p>
                            </div>

                            <div className={`dropdown-menu ${black ? 'black' : ''}`}>
                                <div className="dropdown-item" onClick={() => handleDesignItemClick(ROUTE_PATH.DESIGN_SELECT)}>
                                    <img className="dropdown-icon" src={black ? "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/2-video-template-white.svg" : "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/2-video-template.svg"} alt='' />
                                    <span className="dropdown-text">{i18n.t("web.menu.video.template")}</span>
                                </div>
                            </div>
                        </div>

                        <div ref={urlDropdownRef} className={`item dropdown-container ${isUrlActive ? 'selected' : ''}`}>
                            <div className="dropdown-trigger">
                                <p>{i18n.t("web.menu.make.by.url")}</p>
                            </div>

                            <div className={`dropdown-menu ${black ? 'black' : ''}`}>
                                <div className="dropdown-item" onClick={() => handleUrlItemClick(ROUTE_PATH.YOUTUBE_SHORTS)}>
                                    <img className="dropdown-icon" src={black ? "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/3-youtube-shorts-white.svg" : "https://front.videomonster.com/images-u6yd72dy/common/ai/icons/3-youtube-shorts.svg"} alt='' />
                                    <span className="dropdown-text">{i18n.t("web.menu.youtube.shorts")}</span>
                                </div>
                            </div>
                        </div>

                        <NavLink to={ROUTE_PATH.PAYMENT} className={`item ${currentPath === ROUTE_PATH.PAYMENT ? 'selected' : ''}`}>
                            <p>{i18n.t("navigator.menu.payment")}</p>
                        </NavLink>
                    </>
                )}
            </div>

            <div className="top-bar-right-section">
                {
                    currentUser
                        ? renderLoginAfter()
                        : renderLoginBefore()
                }

                {
                    isShowSignUpSelector &&
                    <ClickAwayListener onClickAway={e => {
                        e.preventDefault()
                        setIsShowSignUpSelector(false)
                    }}>
                        <SignUpSelection
                            handleSignUpDialogOpen={handleSignUpDialogOpen}
                            handleClickThirdPartyLogin={url => {
                                setIsShowSignUpSelector(false)
                                handleClickThirdPartyLogin(url, true)
                            }}
                        />
                    </ClickAwayListener>
                }
            </div>
            <SignUpDialog
                open={isShowSignUpPopup}
                onClose={() => SetIsShowSignUpDialog(false)}
            />
            <LoginDialog
                open={isShowLoginPopup}
                onClose={() => SetIsShowLoginDialog(false)}
                handleClickThirdPartyLogin={handleClickThirdPartyLogin}
            />
        </div>
    );
};

export default TopBarV2;
